import { render, staticRenderFns } from "./storage-save.vue?vue&type=template&id=8aadd3f8"
import script from "./storage-save.vue?vue&type=script&lang=js"
export * from "./storage-save.vue?vue&type=script&lang=js"
import style0 from "./storage-save.vue?vue&type=style&index=0&id=8aadd3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports